import { Alert, Card, CardContent, CardHeader, CardProps } from '@mui/material'
import { RuuviTag } from '../types'
import LoadingState from './LoadingState'
import { useTranslation } from 'react-i18next'
import AlertDataGrid from './AlertDataGrid'
import EnableAlertNotificationsAlert from './EnableAlertNotificationsAlert'
import RuuviTagActiveAlertsWarning from './RuuviTagActiveAlertsWarning'
import { useLoadingAlerts } from '../hooks'

export interface RuuviTagActiveAlertsCardProps extends Omit<CardProps, 'children'> {
  ruuviTag: RuuviTag
}

export default function RuuviTagActiveAlertsCard({
  ruuviTag,
  ...props
}: RuuviTagActiveAlertsCardProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation()

  /**
   * The alerts state.
   */
  const { alerts, loading, error } = useLoadingAlerts({
    ruuvitag: ruuviTag.id,
    source: 'prometheus'
  })

  return (
    <>
      {alerts.length > 0 && (
        <RuuviTagActiveAlertsWarning
          ruuviTag={ruuviTag}
          alerts={alerts}
          sx={{ mb: 6, width: '100%' }}
        />
      )}

      <EnableAlertNotificationsAlert ruuviTag={ruuviTag} sx={{ mb: 6, width: '100%' }} />

      <Card {...props}>
        <CardHeader title={t('activeAlerts')} />
        <CardContent sx={{ pt: 0 }}>
          {loading ? (
            <LoadingState />
          ) : error ? (
            <Alert severity="error">{t('alertsLoadError')}</Alert>
          ) : alerts.length === 0 ? (
            <Alert severity="info">{t('noActiveAlerts')}</Alert>
          ) : (
            <AlertDataGrid alerts={alerts} />
          )}
        </CardContent>
      </Card>
    </>
  )
}
